import { render, staticRenderFns } from "./subjectdetails.vue?vue&type=template&id=441cadd8&"
import script from "./subjectdetails.vue?vue&type=script&lang=js&"
export * from "./subjectdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports